import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Spinner } from 'reactstrap';

type Props = { text?: string };
const LoadingPage: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  return (
    <Container fluid className='d-flex flex-column justify-content-center align-items-center min-vh-100'>
      <Spinner style={{ width: '4rem', height: '4rem' }}></Spinner>
      <h3 className='sr-only'>{props.text ?? t('shell.loadingPage.text')}</h3>
    </Container>
  );
};

export default LoadingPage;
